'use client'
import { useSplitText } from '@/hooks/useSplitText'
import { LazyMotion, domAnimation, m } from 'framer-motion'

export default function TitlePage({
  text,
  subText,
}: {
  text: string
  subText: string
}) {
  const sentence = {
    visible: {
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.045,
      },
    },
  }
  const title = {
    hidden: {
      opacity: 0,
      x: 40,
    },
    visible: {
      opacity: 1,
      x: 0,
      color: ['#000000', '#953F75', '#6E95FF', '#000000'],
      transition: {
        duration: 1.2,
        ease: [0.3, 1, 0.7, 1],
      },
    },
  }
  const sub_sentence = {
    visible: {
      transition: {
        delayChildren: 1,
      },
    },
  }
  const sub = {
    hidden: {
      opacity: 0,
      clipPath: 'polygon(0 0, 0 0, 0 100%, 0% 100%)',
    },
    visible: {
      opacity: 1,
      clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
      transition: {
        duration: 0.8,
        ease: [0.5, 1, 0.35, 1],
      },
    },
  }
  const parts = useSplitText(text)
  return (
    <div className="relative">
      <LazyMotion features={domAnimation} strict>
        <m.h3
          className="text-[28px] md:text-[48px] leading-normal font-bold tracking-[0.02em] md:tracking-[0.04em]"
          variants={sentence}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {text &&
            parts.map((part, index) => {
              if (part.type == 'br') {
                return part.className != undefined ? (
                  <br className={part.className} key={`br-${index}`} />
                ) : (
                  <br key={`br-${index}`} />
                )
              } else {
                return part.value.split('').map((char, i) => (
                  <span key={i} style={{ overflow: 'hidden' }}>
                    <m.span
                      className="title-text"
                      key={char + '-' + i}
                      variants={title}
                      style={{ display: 'inline-block' }}
                    >
                      {char === ' ' ? '\u00A0' : char}
                    </m.span>
                  </span>
                ))
              }
            })}
        </m.h3>
        <p className="relative text-blue_400 leading-normal mt-1">
          <m.span
            className="uppercase text-[16px] md:text-[24px] font-avenirNextBold tracking-[0.04em]"
            variants={sub_sentence}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {subText &&
              subText.split('').map((char, index) => {
                return (
                  <span
                    key={index}
                    style={{ overflow: 'hidden', display: 'inline-block' }}
                  >
                    <m.span
                      key={char + '-' + index}
                      variants={sub}
                      style={{ display: 'inline-block' }}
                    >
                      {char === ' ' ? '\u00A0' : char}
                    </m.span>
                  </span>
                )
              })}
          </m.span>
        </p>
      </LazyMotion>
    </div>
  )
}
